// Generated by purs version 0.15.0
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
import * as Restaumatic_PromotionsEngine_Cart_ProductItem from "../Restaumatic.PromotionsEngine.Cart.ProductItem/index.js";
import * as Restaumatic_PromotionsEngine_Cart_PromotionalItem from "../Restaumatic.PromotionsEngine.Cart.PromotionalItem/index.js";
import * as Restaumatic_PromotionsEngine_MaximalCliques from "../Restaumatic.PromotionsEngine.MaximalCliques/index.js";
import * as Restaumatic_PromotionsEngine_Promotions_Promotion from "../Restaumatic.PromotionsEngine.Promotions.Promotion/index.js";
var AssignmentVertex = function (x) {
    return x;
};
var newtypeAssignmentVertex = {
    Coercible0: function () {
        return undefined;
    }
};
var vertexProductItemKey = /* #__PURE__ */ (function () {
    var $24 = Data_Newtype.unwrap();
    return function ($25) {
        return (function (v) {
            return v.vertexProductItemKey;
        })($24($25));
    };
})();
var vertexPromotionalItem = /* #__PURE__ */ (function () {
    var $26 = Data_Newtype.unwrap();
    return function ($27) {
        return (function (v) {
            return v.vertexPromotionalItem;
        })($26($27));
    };
})();
var vertexPromotion = function ($28) {
    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotion(vertexPromotionalItem($28));
};
var vertexPromotionId = function ($29) {
    return Restaumatic_PromotionsEngine_Promotions_Promotion.promotionId(vertexPromotion($29));
};
var vertexPromotionalItemId = function ($30) {
    return Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionalItemId(vertexPromotionalItem($30));
};
var mkAssignmentVertex = function (promotionalItem) {
    return function (productItemKey) {
        return {
            vertexPromotionalItem: promotionalItem,
            vertexProductItemKey: productItemKey
        };
    };
};
var getAssignedProductIds = /* #__PURE__ */ (function () {
    var $31 = Data_Functor.map(Data_Functor.functorArray)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.assignedProductItemKey);
    return function ($32) {
        return Data_Array.catMaybes($31($32));
    };
})();
var genericAssignmentVertex = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showAssignmentVertex = function (dictShow) {
    return {
        show: Data_Show_Generic.genericShow(genericAssignmentVertex)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()()(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "vertexProductItemKey";
            }
        })(Data_Show.showRecordFieldsCons({
            reflectSymbol: function () {
                return "vertexPromotionalItem";
            }
        })(Data_Show.showRecordFieldsNil)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.showPromotionalItem(dictShow)))(Restaumatic_PromotionsEngine_Cart_ProductItem.showProductItemKey(dictShow)))))({
            reflectSymbol: function () {
                return "AssignmentVertex";
            }
        }))
    };
};
var findPromotionalItem = function (promotionIdToFind) {
    var $33 = Data_Array.filter(function (item) {
        return Data_Eq.eq(Restaumatic_Promotions_Types_Id.eqPromotionId)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.promotionId(item))(promotionIdToFind);
    });
    return function ($34) {
        return Data_Array.head($33($34));
    };
};
var eqAssignmentVertex = function (dictEq) {
    return {
        eq: Data_Eq_Generic.genericEq(genericAssignmentVertex)(Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqArgument(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
            reflectSymbol: function () {
                return "vertexPromotionalItem";
            }
        })(Restaumatic_PromotionsEngine_Cart_PromotionalItem.eqPromotionalItem(dictEq)))()({
            reflectSymbol: function () {
                return "vertexProductItemKey";
            }
        })(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))))))
    };
};
var canCoallocate = function (dictEq) {
    return function (keys1) {
        return function (keys2) {
            return Data_Foldable["null"](Data_Foldable.foldableArray)(Data_Array.intersect(Restaumatic_PromotionsEngine_Cart_ProductItem.eqProductItemKey(dictEq))(keys1)(keys2));
        };
    };
};
var assignmentVertexToItem = function (dictOrd) {
    return function (assignmentVertex) {
        return Restaumatic_PromotionsEngine_Cart_PromotionalItem.setAssignment(dictOrd)(new Restaumatic_PromotionsEngine_Cart_PromotionalItem.AssignmentToProduct(vertexProductItemKey(assignmentVertex)))(vertexPromotionalItem(assignmentVertex));
    };
};
var areNonconflicting = function (dictEq) {
    return function (promotionalItem1) {
        return function (productItemKey1) {
            return function (promotionalItem2) {
                return function (productItemKey2) {
                    var allocatedProductItemKeys2 = Data_Array.cons(productItemKey2)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.sourceProductItems(promotionalItem2));
                    var allocatedProductItemKeys1 = Data_Array.cons(productItemKey1)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.sourceProductItems(promotionalItem1));
                    return canCoallocate(dictEq)(allocatedProductItemKeys1)(allocatedProductItemKeys2) || Restaumatic_PromotionsEngine_Cart_PromotionalItem.canCombineWith(promotionalItem1)(promotionalItem2);
                };
            };
        };
    };
};
var canCoexist = function (dictEq) {
    return function (vertex1) {
        return function (vertex2) {
            var promotionalItemId2 = vertexPromotionalItemId(vertex2);
            var promotionalItemId1 = vertexPromotionalItemId(vertex1);
            var promotionalItem2 = vertexPromotionalItem(vertex2);
            var promotionalItem1 = vertexPromotionalItem(vertex1);
            var productItemKey2 = vertexProductItemKey(vertex2);
            var productItemKey1 = vertexProductItemKey(vertex1);
            return promotionalItemId1 !== promotionalItemId2 && areNonconflicting(dictEq)(promotionalItem1)(productItemKey1)(promotionalItem2)(productItemKey2);
        };
    };
};
var calcBestProductPromotions = function (dictEq) {
    return function (assignmentVertices) {
        var assignmentVerticesClique = Restaumatic_PromotionsEngine_MaximalCliques.getMaximalCliques(canCoexist(dictEq))(assignmentVertices);
        return Data_Maybe.fromMaybe([  ])(Data_Foldable.maximumBy(Data_Foldable.foldableArray)(Data_Ord.comparing(Data_Ord.ordInt)(Data_Array.length))(assignmentVerticesClique));
    };
};
var isNonconflicting = function (dictEq) {
    return function (vertex) {
        return function (userEnabledItem) {
            var v = Restaumatic_PromotionsEngine_Cart_PromotionalItem.assignedProductItemKey(userEnabledItem);
            if (v instanceof Data_Maybe.Nothing) {
                return true;
            };
            if (v instanceof Data_Maybe.Just) {
                return areNonconflicting(dictEq)(vertexPromotionalItem(vertex))(vertexProductItemKey(vertex))(userEnabledItem)(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.ProductAssignment (line 98, column 3 - line 101, column 120): " + [ v.constructor.name ]);
        };
    };
};
var allAssignmentVerticesForItem = function (productIds) {
    return function (promotionalItem) {
        return Data_Functor.map(Data_Functor.functorArray)(mkAssignmentVertex(promotionalItem))(Data_Array.fromFoldable(Data_Set.foldableSet)(productIds));
    };
};
var productItemAssignmentVertices = function (dictOrd) {
    return function (userEnabledItems) {
        return function (promotionalItem) {
            return function (productItemKeys) {
                var isAvailable = function (vertex) {
                    return Data_Foldable.foldl(Data_Foldable.foldableArray)(Data_HeytingAlgebra.conj(Data_HeytingAlgebra.heytingAlgebraBoolean))(true)(Data_Functor.map(Data_Functor.functorArray)(isNonconflicting(dictOrd.Eq0())(vertex))(userEnabledItems));
                };
                var allVertices = allAssignmentVerticesForItem(productItemKeys)(promotionalItem);
                var result = Data_Array.filter(isAvailable)(allVertices);
                return result;
            };
        };
    };
};
var itemAssignmentVertices = function (dictOrd) {
    return function (userEnabledItems) {
        return function (promotionalItem) {
            var v = Restaumatic_PromotionsEngine_Cart_PromotionalItem.target(promotionalItem);
            if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.TargetCart) {
                return [  ];
            };
            if (v instanceof Restaumatic_PromotionsEngine_Cart_PromotionalItem.TargetProductItems) {
                return productItemAssignmentVertices(dictOrd)(userEnabledItems)(promotionalItem)(v.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.PromotionsEngine.Tools.ProductAssignment (line 85, column 3 - line 87, column 121): " + [ v.constructor.name ]);
        };
    };
};
var allAssignmentVerticesForItems = function (dictOrd) {
    return function (userEnabledItems) {
        return Data_Array.concatMap(itemAssignmentVertices(dictOrd)(userEnabledItems));
    };
};
var promotionProductAssignment = function (dictOrd) {
    return function (userEnabledItems) {
        return function (promotionalItems) {
            var assignmentVertices = allAssignmentVerticesForItems(dictOrd)(userEnabledItems)(promotionalItems);
            var assignmentVerticesCliqueBiggestElem = calcBestProductPromotions(dictOrd.Eq0())(assignmentVertices);
            var assignedItems = Data_Functor.map(Data_Functor.functorArray)(assignmentVertexToItem(dictOrd))(assignmentVerticesCliqueBiggestElem);
            var notAssignedItems = Restaumatic_PromotionsEngine_Cart_PromotionalItem.resetPromotionalItems(dictOrd)(Restaumatic_PromotionsEngine_Cart_PromotionalItem.excludeItemsFrom(assignedItems)(promotionalItems));
            return Data_Semigroup.append(Data_Semigroup.semigroupArray)(assignedItems)(notAssignedItems);
        };
    };
};
export {
    promotionProductAssignment,
    allAssignmentVerticesForItems,
    mkAssignmentVertex,
    canCoexist,
    calcBestProductPromotions,
    newtypeAssignmentVertex,
    genericAssignmentVertex,
    showAssignmentVertex,
    eqAssignmentVertex
};
//# sourceMappingURL=index.js.map
